import React from 'react';

import { IconProps } from '../Icon.types';

export function Eye({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Eye</title>
      <path
        d="M21.335 11.4069L22.0349 11.1373L21.335 11.4069ZM21.335 12.5932L20.6351 12.3236L21.335 12.5932ZM2.66492 11.4068L1.96504 11.1373L2.66492 11.4068ZM3.3648 11.6764C4.70047 8.20858 8.06403 5.75 12 5.75V4.25C7.42322 4.25 3.51626 7.1098 1.96504 11.1373L3.3648 11.6764ZM12 5.75C15.9359 5.75 19.2995 8.20859 20.6351 11.6764L22.0349 11.1373C20.4837 7.10981 16.5767 4.25 12 4.25V5.75ZM20.6351 12.3236C19.2995 15.7914 15.9359 18.25 12 18.25V19.75C16.5767 19.75 20.4837 16.8902 22.0349 12.8627L20.6351 12.3236ZM12 18.25C8.06403 18.25 4.70047 15.7914 3.3648 12.3236L1.96504 12.8627C3.51626 16.8902 7.42322 19.75 12 19.75V18.25ZM20.6351 11.6764C20.7153 11.8845 20.7153 12.1155 20.6351 12.3236L22.0349 12.8627C22.2487 12.3076 22.2487 11.6924 22.0349 11.1373L20.6351 11.6764ZM1.96504 11.1373C1.75124 11.6924 1.75124 12.3076 1.96504 12.8627L3.3648 12.3236C3.28465 12.1155 3.28465 11.8845 3.3648 11.6764L1.96504 11.1373Z"
        fill={color ?? 'currentColor'}
      />
      <circle
        cx="12"
        cy="12"
        r="3"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
